module.exports = __webpack_public_path__ + "img/bgLogo.2886fb00.png";